import dayjs from 'dayjs'

interface InfoVoucher {
  value: number
  date: Date
  installments: number
}

const InfoVoucher = ({value, date, installments}: InfoVoucher) => {
  const dateFormat = dayjs(date).format('DD/MM/YYYY')
  return (
    <span className='fw-bold d-block'>
      Voucher: {value} - {dateFormat}
    </span>
  )
}

export {InfoVoucher}
